<template>
  <div>
    <div ref="widgetContainer">
      <Row class="widget-container">
        <i-col :lg="24" :md="24" :sm="24" :xs="24">
          <MyQuestionnaireForm></MyQuestionnaireForm>
        </i-col>
      </Row>
    </div>
  </div>
</template>
<script>
  import MyQuestionnaireForm from './_MyQuestionnaire'
  export default {
    name: 'MyQuestionnaireForms',
    components: {
      MyQuestionnaireForm
    },
    data() {
      return {}
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/d_MyQuestionnaireForms/MyQuestionnaireForms.vue